'use strict';
define([], function () {
    function Controller($scope, $mdDialog, user) {
        $scope.hide = hideDialog;
        $scope.cancel = cancelDialog;
        $scope.goToWorkspace = goToWorkspace;
        $scope.loading = {
            post: false
        };
        $scope.user = user;


        function hideDialog() {
            $mdDialog.hide();
        }

        function cancelDialog() {
            $mdDialog.cancel();
        }

        function goToWorkspace() {
            hideDialog();
        }
    }
    Controller.$inject = ['$scope', '$mdDialog', 'user'];
    return Controller;
});
